module.exports = __webpack_public_path__ + "img/sebrae_jpeg.29049cad.jpeg";